import React, { useState, useEffect } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import useButton from "../../hooks/useButton";
import useModal from "../../hooks/useModal";
import calcIcon from "../../images/Icon_awesome_calculator.svg";
import { ModalBowlers } from "../modal/ModalBowlers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ThumbCuts } from "./ThumCuts";
import HandMismatchModal from "./HandMismatchModal";
import Notify from "../ui/Notify";
import { validateValue } from "../../utils/utils";
import { toDecimal } from "../../utils";
import UpdatingSpinner from "../ui/UpdatingSpinner";

const Button = styled.button`
  display: inline-block;
  margin: 0;
  width: 84px;
  height: 35px;
  background: ${(props) => (props.active === true ? "#D4D4D5" : "#FFFFFF")};
  color: ${(props) => (props.active === true ? "#00147B" : "#00187E")};
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-d4d4d5);
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #d4d4d5;
  opacity: 1;
  font-weight: ${(props) => (props.first === true ? "300" : "700")};

  ${(props) =>
    props.calculateOval &&
    css`
      width: 100%;
      background: #00147b 0% 0% no-repeat padding-box;
      border-radius: 10px;
      opacity: 1;
      color: #ffffff;
      font-size: 14px;
      height: 48px;
    `}
  ${(props) =>
    props.sixColumns &&
    css`
      width: auto;
      min-width: 0;
      height: 44px;
      font-size: ${(props) => (props.first === true ? "16px" : "11px")};
      margin-right: 0;
      border-radius: 8px;
      line-height: 1.1;
      display: inline-grid;
      justify-content: center;
      align-items: center;
      align-content: center;
      background: #00147b 0% 0% no-repeat padding-box;
      color: #ffffff;
      padding: 2px;
      ${(props) =>
        props.first === true &&
        css`
          flex: 0 0 44px;
          width: 44px;
          border-radius: 50%;
        `}
    `}

    ${(props) =>
    props.threeSpaceColumns &&
    css`
      width: auto;
      min-width: 0;
      height: ${(props) => (props.cut === true ? "38px" : "52px")};
      font-size: 13px;
      margin-right: 0;
      padding: 2px;
      line-height: 1.2;
    `}

    ${(props) =>
    props.cut &&
    css`
      width: 32.33%;
      height: 40px;
      font-size: ${(props) =>
        props.first === true
          ? "12px"
          : props.second === true
          ? "10px"
          : "12px"};
      margin-right: ${(props) => (props.last === true ? "0" : "1%")};
      padding: 0;
    `}

    ${(props) =>
    props.fiveSpaceColumns &&
    css`
      width: auto;
      min-width: 0;
      height: 52px;
      font-size: 16px;
      font-weight: 700;
      margin-right: 0;
      padding: 2px;
      line-height: 1.2;
    `}
    
    &:hover {
    background: #00187e;
    color: #ffffff;
  }
`;

const Section = styled.div`
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-d4d4d5);
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 4px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  margin: 1vh 0 1vh 0;

  & > * {
    flex: 1 1 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media only screen and (min-width: 992px) and (max-width: 1439px) and (orientation: landscape) {
    && > * {
      font-size: 14px;
      padding: 1px;
    }
  }
`;

const CircleSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible !important;
`;

const CircleButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #00147b;
  color: #ffffff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 16px;
  flex: 0 0 44px;

  &:hover {
    background: #00187e;
  }
`;

const SectionThmType = styled.div`
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-d4d4d5);
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
  width: 130px;
  display: flex;
  flex_direction: column;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.primary &&
    css`
      width: auto;
    `}
  ${(props) =>
    props.big &&
    css`
      width: auto;
    `}
`;

const DescriptionTextThmType = styled.span`
  font: var(--unnamed-font-style-normal) normal
    var(--unnamed-font-weight-normal) 10px / var(--unnamed-line-spacing-36)
    var(--unnamed-font-family-poppins);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-707070);
  text-align: center;
  font: normal normal normal 10px/36px Poppins;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  display: flex;
  line-height: 1;
  justify-content: center;
`;
const ButtonThmType = styled.button`
  display: inline-block;
  margin: 0.5rem 0;
  width: 52px;
  height: 55px;
  background: ${(props) => (props.active === true ? "#00297A" : "#E0E1E2")};
  color: ${(props) => (props.active === true ? "#FFFFFF" : "#00000099")};
  border: 2px solid white;
  font: normal normal 600 12px/18px Poppins;
  font-weight: 700;
  text-align: center;
  padding: 0;
  vertical-align: bottom;

  ${(props) =>
    props.primary &&
    css`
      padding: 0.5rem 1.5rem;
      margin: 0.5rem 1rem;
      border-radius: 7px;
      width: 110px;
      font: normal normal 600 32px var(--unnamed-font-family-poppins);
      font-weight: 700;
      color: #ffffff;
      opacity: 1;
      letter-spacing: 0px;

      @media only screen and (max-width: 900px) and (orientation: portrait) {
        text-align: center;
        font: normal normal 600 32px/48px Poppins;
        width: 70px;
        padding: 0;
      }
      @media only screen and (max-width: 450px) and (orientation: portrait) {
        padding: 0;
        margin: 0;
        width: 68px;
      }
    `}
  ${(props) =>
    props.left &&
    css`
      border-radius: 8px 0px 0px 8px;
      margin: 0.5rem 0;
    `}
    ${(props) =>
    props.right &&
    css`
      border-radius: 0px 8px 8px 0px;
      margin: 0.5rem 0.01rem;
      width: 53px;
    `}
    ${(props) =>
    props.reduceSize &&
    css`
      font: var(--unnamed-font-style-normal) normal 600
        var(--unnamed-font-size-12) / 15px var(--unnamed-font-family-poppins);
      font: normal normal 600 11px/15px Poppins;
    `}
    
    &:hover {
    background: #00187e;
    color: #ffffff;
  }
`;

const DescriptionText = styled.span`
  font-size: ${(props) => (props.title === true ? "12px" : "11px")};
  letter-spacing: 0px;
  opacity: 1;
  display: flex;
  justify-content: center;
  color: ${(props) => (props.title === true ? "#00187E" : "inherit")};
  margin-left: 3px;
  font-weight: ${(props) => (props.title === true ? "700" : "300")};

  ${(props) =>
    props.title &&
    css`
      justify-content: flex-start;
      margin-left: 0;
    `}
  ${(props) =>
    props.valueDescription &&
    css`
      justify-content: flex-start;
      align-items: center;
      margin: 0.5vh 0 0 0;
      text-transform: uppercase;
      font-weight: 700;
    `}
    ${(props) =>
    props.table &&
    css`
      font-size: 8px;
      justify-content: flex-start;
      align-items: center;
      color: #888888;
    `}
    ${(props) =>
    props.recommendedValue &&
    css`
      font-size: 10px;
      justify-content: center;
      align-items: center;
      color: #888888;
      width: 100%;
    `}
`;

const specContinuedContainerStyle = {
  display: "flex",
  width: "100%",
};
const calculateLogoStyle = {
  width: "17px",
  height: "20px",
  padding: "0",
  margin: "0 7px 0 0",
};

const nameStyle = {
  verticalAlign: "middle",
  textAlign: "left",
  fontSize: "14px",
  fontWeight: "900",
  alignSelf: "flex-start",
};

export const SpecsContinued = ({
  specsheet,
  flip_vh,
  isOval,
  isOvalCalculationVisible,
  specsheetSVGClick,
  isRightHander,
  specsheetCalculateThumbCuts,
  specsheetAddThumbCut,
  specsheetHandleForm,
  specsheetUpdateThumbCut,
  specsheetDeleteThumbCut,
  specsheetSetThumbCuts,
  specsheetShowThumbcutModal,
  showThumbcutModal,
  isOvalWidthDifference,
  isOvalWidthDecimal,
  isOvalWidthStartingBit,
  isCalculating,
  isReadOnly,
  spanMeasurement,
  customerHand,
}) => {
  const [t, i18n] = useTranslation();
  const [showHandMismatch, setShowHandMismatch] = useState(false);

  // Required inputs for the oval calculation (mirrors the epic guard, which
  // otherwise rejects silently). Taper is optional.
  const handleCalculate = () => {
    const missing = [];
    if (!specsheet?.thm_oval_starting_bit)
      missing.push(t("form.label.starting_bit"));
    if (!specsheet?.thm_oval_width) missing.push(t("form.label.oval_width"));
    if (!specsheet?.thm_oval_degree) missing.push(t("form.label.oval_degree"));
    if (missing.length > 0) {
      Notify.warning(
        `${t("message.warning.oval_missing_fields")}: ${missing.join(", ")}`
      );
      return;
    }

    // Then warn if the customer's hand and the spec sheet's hand disagree
    // (Mark's request). Only prompt when both are known and differ.
    const ch = (customerHand || "").toLowerCase();
    const sh = (specsheet?.hand || "").toLowerCase();
    if (ch && sh && ch !== sh) {
      setShowHandMismatch(true);
    } else {
      specsheetCalculateThumbCuts();
    }
  };

  const confirmCalculate = () => {
    setShowHandMismatch(false);
    specsheetCalculateThumbCuts();
  };
  const initialForm = {
    tables: {
      thm_oval_starting_bit: specsheet?.thm_oval_starting_bit,
      thm_oval_width: specsheet?.thm_oval_width,
      thm_oval_difference: isOvalWidthDifference
        ? specsheet &&
          specsheet.thm_oval_width &&
          specsheet.thm_oval_width !== "" &&
          specsheet.thm_oval_starting_bit &&
          specsheet.thm_oval_starting_bit !== ""
          ? (
              toDecimal(specsheet.thm_oval_width, spanMeasurement) -
              toDecimal(specsheet.thm_oval_starting_bit, spanMeasurement)
            ).toFixed(3)
          : specsheet &&
            specsheet.thm_oval_width &&
            specsheet.thm_oval_width !== "" &&
            (!specsheet.thm_oval_starting_bit ||
              specsheet.thm_oval_starting_bit === "")
          ? toDecimal(specsheet.thm_oval_width, spanMeasurement).toFixed(3)
          : "0.000"
        : specsheet
        ? toDecimal(specsheet.thm_oval_width, spanMeasurement).toFixed(3)
        : "0.000",
      thm_oval_degree: specsheet?.thm_oval_degree,
      thm_oval_taper: specsheet?.thm_oval_taper,
      thm_od: specsheet?.thm_od,
      thm_round_taper: specsheet?.thm_round_taper,
      thm_size: specsheet?.thm_size,
      thumb_cuts: specsheet?.thumb_cuts,
      calculate_oval: "",
      axisTilt: "",
      speed: "",
      revRate: "",
      isEdit: "",
    },
  };

  const {
    tables: {
      thm_oval_starting_bit,
      thm_oval_width,
      thm_oval_difference,
      thm_oval_degree,
      thm_oval_taper,
      calculate_oval,
      thm_od,
      thm_round_taper,
      thm_size,
      thumb_cuts,
    },
  } = initialForm;

  const clickableRectOnClickHandler = (field) => {
    if (isReadOnly) return;
    let openDropdown = field;
    if (!isRightHander) {
      if (field.indexOf("f1_") >= 0) {
        openDropdown = field.replace("f1_", "f2_");
      } else if (field.indexOf("f2_") >= 0) {
        openDropdown = field.replace("f2_", "f1_");
      }
    }
    specsheetSVGClick({ openDropdown });
  };

  return (
    specsheet && (
      <>
        <HandMismatchModal
          show={showHandMismatch}
          onHide={() => setShowHandMismatch(false)}
          onConfirm={confirmCalculate}
          customerHand={customerHand}
          specHand={specsheet?.hand}
        />
        {specsheet && (
          <div className="row" style={specContinuedContainerStyle}>
            {isOval ? (
              <>
                <div
                  className="col-12 col-md-6 col-lg-12"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <SectionThmType>
                        <ButtonThmType
                          left
                          onClick={() => {
                            !isReadOnly &&
                              specsheetHandleForm({
                                specsheetValues: { thm_type: "Round" },
                              });
                          }}
                          active={specsheet.thm_type?.toLowerCase() === "round"}
                          name="thm_type"
                          value="Round"
                        >
                          {t("round")}
                        </ButtonThmType>
                        <ButtonThmType
                          right
                          onClick={() => {
                            !isReadOnly &&
                              specsheetHandleForm({
                                specsheetValues: { thm_type: "Oval" },
                              });
                          }}
                          active={specsheet.thm_type?.toLowerCase() === "oval"}
                          name="default_thm_type"
                          value="Oval"
                        >
                          {t("oval")}
                        </ButtonThmType>
                      </SectionThmType>
                      <DescriptionTextThmType>
                        {t("hole_type")}
                      </DescriptionTextThmType>
                    </div>
                    {isOvalCalculationVisible && !isReadOnly && (
                      <Section>
                        <Button
                          calculateOval
                          reduceSize
                          onClick={handleCalculate}
                          title="Calculate Oval"
                          name="calculate_oval"
                          value={calculate_oval}
                          id="tables"
                        >
                          <img
                            style={calculateLogoStyle}
                            src={calcIcon}
                            alt="question logo style"
                          />
                          {t("form.label.calculate_oval")}
                        </Button>
                      </Section>
                    )}
                  </div>
                  <Section>
                    <Button
                      fiveSpaceColumns
                      onClick={() => {
                        clickableRectOnClickHandler("thm_oval_starting_bit");
                      }}
                      name="thm_oval_starting_bit"
                      value={thm_oval_starting_bit}
                    >
                      <DescriptionText>
                        {t("form.label.starting_bit")}
                      </DescriptionText>
                      {validateValue(thm_oval_starting_bit)}
                    </Button>
                    {isOvalWidthStartingBit && (
                      <Button
                        fiveSpaceColumns
                        onClick={() => {
                          clickableRectOnClickHandler("thm_oval_width");
                        }}
                        name="thm_oval_width"
                        value={thm_oval_width}
                      >
                        <DescriptionText>
                          {t("form.label.oval_width")}
                        </DescriptionText>
                        {validateValue(thm_oval_width)}
                      </Button>
                    )}
                    {(isOvalWidthDifference || isOvalWidthDecimal) && (
                      <Button
                        fiveSpaceColumns
                        onClick={() => {
                          clickableRectOnClickHandler("thm_oval_difference");
                        }}
                        name="thm_oval_difference"
                        value={thm_oval_difference}
                      >
                        <DescriptionText>
                          {isOvalWidthDifference
                            ? t("form.label.oval_difference")
                            : t("form.label.oval_width")}
                        </DescriptionText>
                        {validateValue(thm_oval_difference)}
                      </Button>
                    )}
                    <Button
                      fiveSpaceColumns
                      onClick={() => {
                        clickableRectOnClickHandler("thm_oval_degree");
                      }}
                      name="thm_oval_degree"
                      value={thm_oval_degree}
                    >
                      <DescriptionText>
                        {t("form.label.oval_degree")}
                      </DescriptionText>
                      {validateValue(thm_oval_degree) !== ""
                        ? `${thm_oval_degree}°`
                        : ""}
                    </Button>
                    <Button
                      fiveSpaceColumns
                      last
                      onClick={() => {
                        clickableRectOnClickHandler("thm_oval_taper");
                      }}
                      name="thm_oval_taper"
                      value={thm_oval_taper}
                    >
                      <DescriptionText>
                        {" "}
                        {t("form.label.taper")}{" "}
                      </DescriptionText>
                      {validateValue(thm_oval_taper)}
                    </Button>
                  </Section>
                </div>
                <div
                  className="col-12 col-md-6 col-lg-12"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <DescriptionText title={true}>
                    {t("form.label.oval_cuts")}
                  </DescriptionText>
                  {!isReadOnly && (
                    <Section>
                      {/* TODO: implementation edit cuts and squeares */}
                      <CircleSlot>
                        <CircleButton
                          type="button"
                          onClick={() =>
                            specsheetAddThumbCut({ cutType: "new" })
                          }
                          title="Edit Cut"
                          name="isEdit"
                          value="custom"
                          id="tables"
                        >
                          <FontAwesomeIcon icon={["fas", "plus"]} />
                        </CircleButton>
                      </CircleSlot>
                      <Button
                        sixColumns
                        second
                        onClick={() =>
                          specsheetAddThumbCut({ cutType: "half" })
                        }
                        title="Edit Cut"
                        name="isEdit"
                        value="taper"
                        id="tables"
                      >
                        {t("form.label.taper")}
                      </Button>
                      <Button
                        sixColumns
                        onClick={() =>
                          specsheetAddThumbCut({ cutType: "half_back" })
                        }
                        title="Edit Cut"
                        name="isEdit"
                        value="1/2back"
                        id="tables"
                      >
                        1/2
                        <DescriptionText valueDescription>
                          {t("form.label.back")}
                        </DescriptionText>
                      </Button>
                      <Button
                        sixColumns
                        onClick={() =>
                          specsheetAddThumbCut({ cutType: "half_front" })
                        }
                        title="Edit Cut"
                        name="isEdit"
                        value="1/2front"
                        id="tables"
                      >
                        1/2
                        <DescriptionText valueDescription>
                          {t("form.label.front")}
                        </DescriptionText>
                      </Button>
                      <Button
                        sixColumns
                        onClick={() =>
                          specsheetAddThumbCut({ cutType: "quarter_back" })
                        }
                        title="Edit Cut"
                        name="isEdit"
                        value="1/4back"
                        id="tables"
                      >
                        1/4
                        <DescriptionText valueDescription>
                          {t("form.label.back")}
                        </DescriptionText>
                      </Button>
                      <Button
                        sixColumns
                        last
                        onClick={() =>
                          specsheetAddThumbCut({ cutType: "quarter_front" })
                        }
                        title="Edit Cut"
                        name="isEdit"
                        value="1/4front"
                        id="tables"
                      >
                        1/4
                        <DescriptionText valueDescription>
                          {t("form.label.front")}
                        </DescriptionText>
                      </Button>
                    </Section>
                  )}
                  {isCalculating && <UpdatingSpinner />}
                  {!isCalculating && specsheet && specsheet.thumb_cuts && (
                    <ThumbCuts
                      thumb_cuts={specsheet.thumb_cuts.sort((t1, t2) =>
                        t1.cut_number * 1 <= t2.cut_number * 1 ? -1 : 1
                      )}
                      specsheetShowThumbcutModal={specsheetShowThumbcutModal}
                      showThumbcutModal={showThumbcutModal}
                      isReadOnly={isReadOnly}
                      flip_vh={flip_vh}
                    />
                  )}
                </div>
              </>
            ) : (
              <>
                <div
                  className="col-12 col-md-6 col-lg-12"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span style={nameStyle}>
                        {t("form.label.specs_continued")}{" "}
                      </span>
                      <DescriptionText title={true}>
                        {t("form.label.thumb_info")}
                      </DescriptionText>
                    </div>
                    <div>
                      <SectionThmType>
                        <ButtonThmType
                          left
                          onClick={() => {
                            specsheetHandleForm({
                              specsheetValues: { thm_type: "Round" },
                            });
                          }}
                          active={specsheet.thm_type?.toLowerCase() === "round"}
                          name="thm_type"
                          value="Round"
                        >
                          {t("round")}
                        </ButtonThmType>
                        <ButtonThmType
                          right
                          onClick={() => {
                            specsheetHandleForm({
                              specsheetValues: { thm_type: "Oval" },
                            });
                          }}
                          active={specsheet.thm_type?.toLowerCase() === "oval"}
                          name="default_thm_type"
                          value="Oval"
                        >
                          {t("oval")}
                        </ButtonThmType>
                        <DescriptionTextThmType>
                          {t("hole_type")}
                        </DescriptionTextThmType>
                      </SectionThmType>
                    </div>
                  </div>
                  <Section>
                    <Button
                      threeSpaceColumns
                      onClick={() => {
                        clickableRectOnClickHandler("thm_size");
                      }}
                      name="thm_size"
                      value={thm_size}
                    >
                      <DescriptionText>{t("form.label.size")}</DescriptionText>
                      {validateValue(thm_size)}
                    </Button>
                    <Button
                      threeSpaceColumns
                      onClick={() => {
                        clickableRectOnClickHandler("thm_od");
                      }}
                      name="thm_od"
                      value={thm_od}
                    >
                      <DescriptionText>
                        {t("form.label.insert_OD")}
                      </DescriptionText>
                      {validateValue(thm_od)}
                    </Button>
                    <Button
                      threeSpaceColumns
                      last
                      onClick={() => {
                        clickableRectOnClickHandler("thm_round_taper");
                      }}
                      name="thm_round_taper"
                      value={thm_round_taper}
                    >
                      <DescriptionText>
                        {t("form.label.taper_size")}
                      </DescriptionText>
                      {validateValue(thm_round_taper) !== ""
                        ? `${thm_round_taper}`
                        : ""}
                    </Button>
                  </Section>
                </div>
              </>
            )}
          </div>
        )}
      </>
    )
  );
};
